import React, { useEffect, useState } from "react";
import { Image } from "@react-pdf/renderer";
import QRCode from "qrcode";

const DynamicQRCode = ({ data, width = 82, height = 82 }) => {
  const [qrImage, setQrImage] = useState("");

  const generateQR = async () => {
    try {
      const qrUrl = await QRCode.toDataURL(data);
      // const qrUrl = await QRCode.toDataURL(JSON.stringify(data));
      setQrImage(qrUrl);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (data) {
      generateQR();
    }
  }, [data]);

  if (!qrImage) return null;

  return (
    <Image
      src={qrImage}
      style={{
        width,
        height,
        
      }}
    />
  );
};

export default DynamicQRCode;
